import Vue from 'vue';
import Component from 'vue-class-component';
import loadjs from 'loadjs';
import { sendItemToAnalytics } from 'common/utils/sendAnalyticsEvent';
import { Watch } from 'vue-property-decorator';
import AboutGift from 'components/AboutGift';
import BaseProductReview from 'components/BaseProductReview';
import NewBoxBlock from 'components/NewBoxBlock';
import BoxInformation from 'components/BoxInformation';
import BreadCrumb from 'components/BreadCrumb';
import CountDown from 'components/CountDown';
import BoxActivitiesResults from 'components/BoxActivitiesResults/BoxActivitiesResults.vue';
import AddToCartMutation from 'assets/graphql/mutations/AddToCartMutation.graphql';
import CartQuery from 'assets/graphql/queries/Cart.graphql';
import BoxQuery from 'assets/graphql/queries/Box.graphql';
import RelatedBoxes from 'assets/graphql/queries/RelatedBoxes.graphql';
import GiftsQuery from 'assets/graphql/queries/account/UserGiftsCompact.graphql';
import SelectionMenuTabsComponent from 'common/components/SelectionMenuTabs';
import getBoxPrice from 'services/getBoxPrice';
import moment from 'common/deps/moment';
import { useBoxCatalogViewStore } from 'stores/boxCatalogView.store.js';
import useAccount from 'composables/useAccount';
import useShoppingCartCleanUp from 'composables/useShoppingCartCleanUp';
import useCatalogFilters from 'composables/useCatalogFilters';
import CatalogPreviewModal from 'components/Catalog/CatalogPreviewModal/CatalogPreviewModal.vue';

@Component({
  apollo: {
    cart: {
      query: CartQuery,
    },
    box: {
      query: BoxQuery,
      variables() {
        return {
          box_slug: this.$route.params.boxSlug,
        };
      },
      update(data) {
        this.breadcrumb = JSON.parse(data.box.path);
        this.isBoxFriendDay = data.box.is_friends_day;
        if (this.isBoxFriendDay) {
          this.availableExperiencieToBoxFriendDay =
            moment() > moment(this.lastDateString);
          this.saleButtonText = 'Regalar';
        }
        this.availableBox = data.box.available;
        this.sendAnalytics(data.box);
        return data.box;
      },
    },
    related_boxes: {
      query: RelatedBoxes,
      variables() {
        return {
          box_slug: this.$route.params.boxSlug,
        };
      },
      skip() {
        return !this.box;
      },
    },
    gifts: GiftsQuery,
  },
  metaInfo() {
    if (this.$apollo.queries.box.loading) return {};

    // Get the canonical URL without parameters
    const canonicalUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname;

    // Define the domain
    const domain = window.location.host;

    let newtitle = `${this.box.name} - Regalá experiencias - Regalos Bigbox `;

    if (
      domain.includes('.cl') ||
      domain.includes('.com.mx') ||
      domain.includes('.com.co') ||
      domain.includes('.pe')
    ) {
      newtitle = `${this.box.name} - Regala experiencias - Regalos Bigbox `;
    }

    const temporalDivElement = document.createElement('div');
    temporalDivElement.innerHTML = this.box.description;
    const boxDescription =
      temporalDivElement.textContent || temporalDivElement.innerText || '';
    const metaTags = {
      title: newtitle,
      meta: [
        {
          name: 'description',
          content: boxDescription,
          vmid: 'description',
        },
        {
          name: 'keywords',
          content: `${this.$store.defaultKeywords} ${this.box.category.keywords}`,
          vmid: 'keywords',
        },
        { property: 'og:title', content: newtitle, vmid: 'ogTitle' },
        { property: 'og:url', content: window.location.href, vmid: 'ogUrl' },
        { property: 'og:type', content: 'product', vmid: 'ogType' },
      ],
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl, // Set the canonical URL without query parameters
          vmid: 'canonical',
        },
      ],
    };
    if (this.box.physical_images.length >= 1) {
      metaTags.meta.push({
        property: 'og:image',
        content: this.box.physical_images[0].image.replace('https', 'http'),
        vmid: 'ogImage',
      });
      metaTags.meta.push({
        property: 'og:image:secure_url',
        content: this.box.physical_images[0].image,
        vmid: 'ogSecureImage',
      });
    }
    return metaTags;
  },
  components: {
    CatalogPreviewModal,
    BaseProductReview,
    NewBoxBlock,
    BoxInformation,
    AboutGift,
    SelectionMenuTabsComponent,
    BreadCrumb,
    CountDown,
    BoxActivitiesResults,
  },
  methods: {
    getBoxPrice,
  },
  setup() {
    const catalogViewStore = useBoxCatalogViewStore();
    const { getModalPreviewFlag, onToggleModalPreview } = useCatalogFilters();
    const { shoppingCartCleanUp } = useShoppingCartCleanUp();
    const { getUserData } = useAccount();
    const {
      getFacets,
      getCurrentFilters,
      getCurrentTags,
      getOptionCards,
      getCardSelected,
      getResults,
      getLoading,
      getPageInfo,
      setKeywords,
      getBoxes,
      getActivities,
      getTravel,
      getDataFromFilters,
      setCard,
      setBoxCategory,
      clearCurrentFilters,
      setBoxId,
      setCatalogOrderType,
    } = useCatalogFilters();
    return {
      catalogViewStore,
      getUserData,
      shoppingCartCleanUp,
      facets: getFacets,
      currentFilters: getCurrentFilters,
      currentTags: getCurrentTags,
      cardSelected: getCardSelected,
      optionCards: getOptionCards,
      results: getResults,
      loading: getLoading,
      pageInfo: getPageInfo,
      getBoxes,
      setKeywords,
      getActivities,
      getTravel,
      getDataFromFilters,
      setCard,
      setBoxCategory,
      clearCurrentFilters,
      setBoxId,
      showPreviewModal: getModalPreviewFlag,
      onToggleModalPreview,
      setCatalogOrderType,
    };
  },
})
export default class BaseBoxViewComponent extends Vue {
  /**
   * positionSelected represents the box that has been selected
   * that can go from 0 to N number of boxes once selected some
   * positionSelected happens to have some value according to that
   * range of possibility which allows me to show an experiencePreview.
   */
  breadcrumb = undefined;
  loading = false;
  availableBox = '';
  numberOfBoxesToShow = 9;
  scrollPosition = null;
  showPreview = false;
  mercadoPagoScriptTag = null;
  isBoxFriendDay = null;
  showRelatedBoxes = false;
  saleButtonText = 'Comprar';
  availableExperiencieToBoxFriendDay = null;
  lastDateString = '2021/07/20';

  async mounted() {
    this.loadMpScript();
    await this.catalogViewStore.init(this.$route.params.boxSlug);
    this.setCatalogOrderType('box_catalog_buyer');
  }

  @Watch('$route.fullPath')
  async onRouteChanged() {
    await this.catalogViewStore.init(this.$route.params.boxSlug);
  }

  sendAnalytics(box) {
    // IDK the query run twice
    if (!this.sentToAnalytics) {
      sendItemToAnalytics('view_item', [box], undefined, {
        userData: {
          email: this.email,
        },
      });
      this.sentToAnalytics = true;
    }
    return;
  }

  beforeDestroy() {
    this.mercadoPagoScriptTag.remove();
  }

  /**
   * Import script tag of mercado pago. We do it like this because the script tag attribute its required, and the loadjs
   * library dosen't support param for the attributes.
   */
  loadMpScript() {
    loadjs('https://www.mercadopago.com/v2/security.js', () => {
      this.mercadoPagoScriptTag = document.querySelectorAll(
        "script[src='https://www.mercadopago.com/v2/security.js']",
      )[0];
      this.mercadoPagoScriptTag.setAttribute('view', 'item');
    });
  }

  // Creo que esto no se usa, ya que el evento está en BoxInformation
  async addToCart() {
    this.loading = !this.loading;
    const data = {
      boxId: this.box.id ? this.box.id.toString() : '',
      activityId: '',
      quantity: 1,
      isGroup: false,
      source: '',
      boxType: 'digital',
      sellingSpotId: '',
      kindId: '',
    };

    await this.shoppingCartCleanUp(this.cart, data);

    const response = await this.$apollo.mutate({
      mutation: AddToCartMutation,
      variables: data,
    });

    if (response.data.update_cart_item.ok) {
      window.location = `https://${
        window.location.host + response.data.update_cart_item.redirect_url
      }`;
    } else {
      this.loading = !this.loading;
    }
  }

  showCart() {
    this.$emit('showCart');
  }

  finished() {
    this.availableExperiencieToBoxFriendDay = true;
  }

  get catalogFriendsDay() {
    return this.isBoxFriendDay && !this.availableExperiencieToBoxFriendDay;
  }

  lastPageChanged(status) {
    this.showRelatedBoxes = status;
  }

  showOverlay() {
    this.$emit('showOverlay');
  }

  get boxGift() {
    const gifts = this.gifts?.filter(gift => gift.product.id === this.box.id);
    return gifts ? gifts[gifts.length - 1] : null;
  }

  get giftInfo() {
    if (this.boxGift) {
      return {
        status: this.boxGift.status,
        signed_code_id: this.boxGift.signed_code_id,
        expiration_date: this.boxGift.expiration_date,
      };
    }
    return null;
  }

  get email() {
    return this.getUserData?.email || '';
  }
}
